'use es6';

import { UPDATED_TEST_FLAGS } from 'ContentEditorUI/redux/actions/actionTypes';
export const updateTestFlags = testFlags => {
  return {
    type: UPDATED_TEST_FLAGS,
    payload: testFlags
  };
};